// VEPC Gestao - Central Administrativa: Gerenciamento de Empresas e Clientes Beta
import { api } from '../api.js';
import { escapeHtml } from '../utils.js';

export async function renderEmpresas() {
  const container = document.createElement('div');
  container.className = 'view-content';

  container.innerHTML = `
    <div class="view-header">
      <div class="view-title-group">
        <div style="display: flex; align-items: center; gap: 10px;">
          <h2>Empresas Clientes & Programa BETA</h2>
          <span class="badge badge-beta">GARANTIA VITALÍCIA</span>
        </div>
        <p>Gerenciamento centralizado de clientes, planos contratados, módulos adicionais, ativação de contas e proteção de preços.</p>
      </div>
      <div class="view-actions">
        <button class="btn btn-primary" id="btn-nova-empresa">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Cadastrar Nova Empresa
        </button>
      </div>
    </div>

    <!-- Barra de Filtros e Busca Rápida -->
    <div class="card-panel" style="padding: 16px 20px; margin-bottom: 20px;">
      <div style="display: flex; gap: 14px; flex-wrap: wrap; align-items: center;">
        <div style="flex-grow: 1; min-width: 260px;">
          <input type="text" id="filtro-busca" class="form-control" placeholder="Buscar por nome fantasia, razão social ou responsável..." />
        </div>
        <div>
          <select id="filtro-situacao" class="form-control" style="width: 190px;">
            <option value="">Todas as Situações</option>
            <option value="ativa">Ativas Contratadas</option>
            <option value="avaliacao">Em Teste Gratuito (7 Dias)</option>
            <option value="pendente">Aguardando Ativação</option>
            <option value="limitada">Inadimplentes / Limitadas</option>
            <option value="inativa">Inativas</option>
          </select>
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <input type="checkbox" id="filtro-apenas-beta" style="width: 16px; height: 16px; cursor: pointer;" />
          <label for="filtro-apenas-beta" style="font-size: 13px; font-weight: 700; color: var(--vepc-dourado-claro); cursor: pointer;">
            Apenas Clientes BETA ⭐
          </label>
        </div>
        <button class="btn btn-secondary btn-sm" id="btn-filtrar">Filtrar</button>
      </div>
    </div>

    <!-- Tabela de Empresas -->
    <div class="card-panel">
      <div class="table-responsive">
        <table class="data-table" id="tabela-empresas">
          <thead>
            <tr>
              <th>Empresa / Razão Social</th>
              <th>Categoria</th>
              <th>Plano Contratado</th>
              <th>Módulos Ativos</th>
              <th>Valor Mensal</th>
              <th>Venc.</th>
              <th>Situação / 7 Dias</th>
              <th>Limite IA</th>
              <th style="text-align: right;">Ações</th>
            </tr>
          </thead>
          <tbody id="corpo-tabela-empresas">
            <tr><td colspan="9" style="text-align: center; padding: 30px;">Carregando empresas cadastradas...</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    <div id="modal-container"></div>
  `;

  const tbody = container.querySelector('#corpo-tabela-empresas');
  const modalContainer = container.querySelector('#modal-container');

  async function carregarEmpresas() {
    const busca = container.querySelector('#filtro-busca').value;
    const situacao = container.querySelector('#filtro-situacao').value;
    const apenasBeta = container.querySelector('#filtro-apenas-beta').checked;

    let qs = `?busca=${encodeURIComponent(busca)}&situacao=${encodeURIComponent(situacao)}`;
    if (apenasBeta) qs += '&apenas_beta=1';

    try {
      const data = await api.getEmpresas(qs);
      const empresas = data.empresas || [];

      if (empresas.length === 0) {
        tbody.innerHTML = `<tr><td colspan="9" style="text-align: center; padding: 40px; color: var(--vepc-text-muted);">Nenhuma empresa encontrada com os filtros informados.</td></tr>`;
        return;
      }

      tbody.innerHTML = empresas.map(e => {
        const valorFormatado = e.valor_mensal_contratado_centavos
          ? `R$ ${(e.valor_mensal_contratado_centavos / 100).toFixed(2).replace('.', ',')}`
          : (e.plano_preco_centavos ? `R$ ${(e.plano_preco_centavos / 100).toFixed(2).replace('.', ',')}` : '—');

        // Situação e Teste de 7 Dias
        let badgeSituacao = `<span class="badge badge-${e.situacao}">${e.situacao.toUpperCase()}</span>`;
        if (e.convite_status === 'pendente') {
          badgeSituacao = `<span class="badge badge-pendente">CONVITE NÃO GERADO</span>`;
        } else if (e.convite_status === 'gerado_envio_pendente' || e.convite_status === 'enviado') {
          badgeSituacao = `<span class="badge badge-aguardando" title="Token gerado; envio de e-mail pendente de integração">CONVITE GERADO — ENVIO PENDENTE</span>`;
        } else if (e.situacao === 'avaliacao' || e.assinatura_status === 'avaliacao') {
          badgeSituacao = `<span class="badge badge-avaliacao">TESTE 7 DIAS ATIVO</span>`;
        }

        // Módulos
        const modulosList = [];
        if (e.modulo_financeiro_ativo) modulosList.push('<span class="badge badge-sucesso">Financeiro</span>');
        if (e.modulo_ia_ativo) modulosList.push('<span class="badge badge-avaliacao">Chat IA</span>');
        if (modulosList.length === 0) modulosList.push('<span style="color: var(--vepc-text-subtle); font-size: 11px;">Apenas Básico</span>');

        // Ações de Convite (O administrador gera o convite; o envio de e-mail é pendente de integração)
        const precisaGerarConvite = (e.convite_status === 'pendente' && !e.ativada_em);
        const podeRegerarConvite = (e.convite_status === 'gerado_envio_pendente' && !e.ativada_em);

        return `
          <tr>
            <td>
              <div style="display: flex; align-items: center; gap: 10px;">
                <div style="width: 32px; height: 32px; border-radius: 6px; background: #1E293B; display: flex; align-items: center; justify-content: center; font-weight: 800; color: #94A3B8; font-size: 13px; border: 1px solid var(--vepc-border);">
                  ${escapeHtml(e.nome_fantasia ? e.nome_fantasia.charAt(0).toUpperCase() : 'E')}
                </div>
                <div>
                  <div style="font-weight: 800; color: #FFFFFF;">${escapeHtml(e.nome_fantasia)}</div>
                  <div style="font-size: 11.5px; color: var(--vepc-text-muted);">${escapeHtml(e.razao_social || 'Razão social não informada')}</div>
                </div>
              </div>
            </td>
            <td>
              ${e.cliente_beta
                ? '<span class="badge badge-beta" title="Preço de adesão protegido vitaliciamente">⭐ BETA</span>'
                : '<span class="badge badge-aberto">PADRÃO</span>'}
            </td>
            <td>
              <div style="font-weight: 700; color: #CBD5E1;">${escapeHtml(e.plano_nome || 'Sem plano')}</div>
              <div style="font-size: 11px; color: var(--vepc-text-subtle);">${escapeHtml(e.plano_codigo || '')}</div>
            </td>
            <td>
              <div style="display: flex; gap: 4px; flex-wrap: wrap;">
                ${modulosList.join(' ')}
              </div>
            </td>
            <td>
              <span class="price-pill" style="color: ${e.cliente_beta ? 'var(--vepc-dourado-claro)' : '#FFFFFF'};">
                ${valorFormatado}
              </span>
            </td>
            <td style="color: var(--vepc-text-muted); font-size: 12px;">
              ${e.dia_vencimento ? `Dia ${e.dia_vencimento}` : '—'}
            </td>
            <td>
              ${badgeSituacao}
              ${e.avaliacao_ate ? `<div style="font-size: 10.5px; color: var(--vepc-text-subtle); margin-top: 2px;">Válido até: ${e.avaliacao_ate}</div>` : ''}
              ${e.ativada_em ? `<div style="font-size: 10px; color: #10B981;">Ativada em: ${e.ativada_em}</div>` : ''}
            </td>
            <td>
              <span style="font-size: 11px; color: #94A3B8; font-family: var(--font-mono);" title="Parâmetro demonstrativo configurável">
                ${e.limite_mensal_mensagens_ia || 200} msgs/mês <small style="color: #64748B;">(demo)</small>
              </span>
            </td>
            <td style="text-align: right; white-space: nowrap;">
              ${precisaGerarConvite ? `
                <button class="btn btn-gold btn-sm btn-enviar-convite" data-id="${e.id}" data-nome="${escapeHtml(e.nome_fantasia)}" title="Gerar link individual de primeiro acesso para o cliente">
                  Gerar Convite
                </button>
              ` : ''}
              ${podeRegerarConvite ? `
                <button class="btn btn-secondary btn-sm btn-reenviar-convite" data-id="${e.id}" data-nome="${escapeHtml(e.nome_fantasia)}" title="Regerar link de acesso sem reiniciar o período de avaliação">
                  Regerar Convite
                </button>
              ` : ''}
              <button class="btn btn-secondary btn-sm btn-ver-detalhe" data-id="${e.id}">
                Gerenciar
              </button>
            </td>
          </tr>
        `;
      }).join('');

      // Eventos de Gerenciamento
      tbody.querySelectorAll('.btn-ver-detalhe').forEach(btn => {
        btn.addEventListener('click', () => abrirModalDetalhes(btn.dataset.id));
      });

      // Evento: Enviar Convite
      tbody.querySelectorAll('.btn-enviar-convite').forEach(btn => {
        btn.addEventListener('click', async () => {
          const empId = btn.dataset.id;
          const empNome = btn.dataset.nome || 'Empresa';
          try {
            const res = await api.enviarConvite(empId);
            exibirModalConvite(res, empNome);
            carregarEmpresas();
          } catch (err) {
            alert('Erro ao enviar convite: ' + err.message);
          }
        });
      });

      // Evento: Reenviar Convite
      tbody.querySelectorAll('.btn-reenviar-convite').forEach(btn => {
        btn.addEventListener('click', async () => {
          const empId = btn.dataset.id;
          const empNome = btn.dataset.nome || 'Empresa';
          try {
            const res = await api.reenviarConvite(empId);
            exibirModalConvite(res, empNome);
            carregarEmpresas();
          } catch (err) {
            alert('Erro ao reenviar convite: ' + err.message);
          }
        });
      });

    } catch (err) {
      tbody.innerHTML = `<tr><td colspan="9" style="text-align: center; color: var(--vepc-danger); padding: 30px;">Falha ao carregar empresas: ${err.message}</td></tr>`;
    }
  }

  // MODAL DE DETALHES E CONTRATO DA EMPRESA
  async function abrirModalDetalhes(empresaId) {
    modalContainer.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-card" style="max-width: 800px;">
          <div class="modal-header">
            <h3>Carregando Detalhes da Empresa...</h3>
            <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
          </div>
          <div class="modal-body" style="text-align: center; padding: 40px; color: var(--vepc-text-muted);">Carregando dados da empresa...</div>
        </div>
      </div>
    `;

    modalContainer.querySelector('.btn-fechar-modal').onclick = () => { modalContainer.innerHTML = ''; };

    try {
      const data = await api.getEmpresa(empresaId);
      const emp = data.empresa;
      const usuarios = data.usuarios || [];
      const contratos = data.historico_contratos || [];

      modalContainer.innerHTML = `
        <div class="modal-backdrop">
          <div class="modal-card" style="max-width: 840px;">
            <div class="modal-header">
              <div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <h3 style="font-size: 18px; font-weight: 800; color: #FFFFFF;">${escapeHtml(emp.nome_fantasia)}</h3>
                  ${emp.cliente_beta ? '<span class="badge badge-beta">⭐ CLIENTE BETA</span>' : ''}
                  <span class="badge badge-${escapeHtml(emp.situacao)}">${escapeHtml(emp.situacao.toUpperCase())}</span>
                </div>
                <div style="font-size: 12px; color: var(--vepc-text-muted); margin-top: 2px;">
                  ID: <code style="font-family: var(--font-mono); color: #94A3B8;">${escapeHtml(emp.id)}</code> &bull; Gestor: ${escapeHtml(emp.responsavel_nome)} &bull; E-mail: ${escapeHtml(emp.responsavel_email || 'Não informado')}
                </div>
              </div>
              <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
            </div>

            <div class="modal-body">
              <!-- Cartão de Contrato em Vigor -->
              <div style="background: var(--vepc-surface-subtle); border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 18px; margin-bottom: 20px;">
                <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;">
                  <div>
                    <span style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--vepc-text-muted);">Contrato Atual em Vigor</span>
                    <div style="font-size: 18px; font-weight: 800; color: #FFFFFF; margin-top: 2px;">
                      ${escapeHtml(emp.plano_nome || 'Sem plano associado')}
                    </div>
                  </div>
                  <div style="text-align: right;">
                    <span style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--vepc-text-muted);">Valor Mensal Contratado</span>
                    <div class="price-pill" style="font-size: 22px; color: var(--vepc-dourado-claro);">
                      R$ ${((emp.valor_mensal_contratado_centavos || 1990) / 100).toFixed(2).replace('.', ',')}/mês
                    </div>
                  </div>
                </div>

                <div style="border-top: 1px dashed var(--vepc-border); padding-top: 12px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; font-size: 12.5px;">
                  <div>
                    <strong style="color: #CBD5E1;">Garantia Beta:</strong><br/>
                    ${emp.protecao_preco_original ? '<span style="color: #34D399;">✅ Preço Protegido</span>' : '<span style="color: #94A3B8;">⚪ Padrão</span>'}
                  </div>
                  <div>
                    <strong style="color: #CBD5E1;">Módulo Financeiro:</strong><br/>
                    ${emp.modulo_financeiro_ativo ? '<span style="color: #38BDF8;">✅ Ativo (+R$ 10,00)</span>' : '<span style="color: #64748B;">⚪ Inativo</span>'}
                  </div>
                  <div>
                    <strong style="color: #CBD5E1;">Chat com IA:</strong><br/>
                    ${emp.modulo_ia_ativo ? '<span style="color: #38BDF8;">✅ Ativo (+R$ 10,00)</span>' : '<span style="color: #64748B;">⚪ Inativo</span>'}
                  </div>
                  <div>
                    <strong style="color: #CBD5E1;">Limite Mensal IA:</strong><br/>
                    <span style="color: #F8FAFC; font-family: var(--font-mono);">${emp.limite_mensal_mensagens_ia || 200} msgs/mês</span>
                    <span style="font-size: 10px; color: var(--vepc-text-subtle);"> (configurável demo)</span>
                  </div>
                </div>
              </div>

              <!-- Gestão de Convite & Primeiro Acesso do Cliente (Marco Zero 7 Dias) -->
              <div class="card-panel" style="margin-bottom: 20px;">
                <div class="panel-header">
                  <span class="panel-title" style="font-size: 13.5px;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                    Acesso do Cliente & Ativação dos 7 Dias Gratuitos
                  </span>
                  <span class="badge badge-${emp.convite_status === 'ativado' ? 'sucesso' : 'pendente'}">
                    ${emp.convite_status === 'gerado_envio_pendente' ? 'CONVITE GERADO — ENVIO PENDENTE' : (emp.convite_status ? emp.convite_status.toUpperCase() : 'PENDENTE')}
                  </span>
                </div>
                <div class="panel-body" style="padding: 16px;">
                  <p style="font-size: 12.5px; color: var(--vepc-text-muted); margin-bottom: 12px;">
                    O período de 7 dias de avaliação gratuita <strong>inicia exclusivamente após o cliente concluir o primeiro acesso e criar a própria senha</strong> no aplicativo Android. O administrador da VEPC somente gera o convite.
                  </p>

                  <div style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap;">
                    ${emp.ativada_em ? `
                      <span style="font-size: 11.5px; color: #10B981; font-weight: 700;">
                        ✔ Conta ativada em ${emp.ativada_em} &bull; Avaliação até ${emp.avaliacao_ate || '—'}
                      </span>
                    ` : `
                      <button class="btn btn-gold btn-sm" id="btn-modal-convite">
                        ${emp.convite_status === 'gerado_envio_pendente' ? 'Regerar Convite (Envio Pendente)' : 'Gerar Convite de Primeiro Acesso'}
                      </button>
                      <span style="font-size: 11px; color: var(--vepc-text-muted);">
                        🔒 Ativação via endpoint de onboarding do cliente. Administradores não ativam manualmente.
                      </span>
                    `}
                  </div>
                </div>
              </div>

              <!-- Formulário de Alteração Voluntária de Contrato -->
              <div class="card-panel" style="margin-bottom: 20px;">
                <div class="panel-header">
                  <span class="panel-title" style="font-size: 13.5px;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                    Ajuste Voluntário de Contrato & Módulos
                  </span>
                </div>
                <div class="panel-body" style="padding: 16px;">
                  <form id="form-alterar-contrato">
                    <div style="display: flex; gap: 16px; margin-bottom: 14px;">
                      <label class="module-switch" style="flex: 1;">
                        <input type="checkbox" id="check-mod-fin" ${emp.modulo_financeiro_ativo ? 'checked' : ''} style="width: 18px; height: 18px;" />
                        <span>Módulo Financeiro (+R$ 10,00)</span>
                      </label>
                      <label class="module-switch" style="flex: 1;">
                        <input type="checkbox" id="check-mod-ia" ${emp.modulo_ia_ativo ? 'checked' : ''} style="width: 18px; height: 18px;" />
                        <span>Módulo Chat com IA (+R$ 10,00)</span>
                      </label>
                    </div>

                    <div style="display: flex; align-items: center; justify-content: space-between; background: var(--vepc-surface-subtle); padding: 12px 16px; border-radius: var(--radius-sm); border: 1px solid var(--vepc-border); margin-bottom: 12px;">
                      <span style="font-size: 13px; font-weight: 700; color: #CBD5E1;">Novo Valor Mensal Calculado:</span>
                      <span id="label-novo-valor" class="price-pill" style="font-size: 18px; color: var(--vepc-dourado-claro);">
                        R$ ${((emp.valor_mensal_contratado_centavos || 1990) / 100).toFixed(2).replace('.', ',')}/mês
                      </span>
                    </div>

                    <div class="form-group" style="margin-bottom: 12px;">
                      <label class="form-label">Justificativa da Alteração Contratual (Auditada):</label>
                      <input type="text" id="input-justificativa" class="form-control" placeholder="Ex: Solicitação voluntária do cliente para adicionar módulo IA..." required />
                    </div>

                    <button type="submit" class="btn btn-primary btn-sm">
                      Gravar Alteração de Contrato (Auditoria Imutável)
                    </button>
                  </form>
                </div>
              </div>

              <!-- Histórico Contratual Imutável -->
              <div class="card-panel" style="margin-bottom: 0;">
                <div class="panel-header">
                  <span class="panel-title" style="font-size: 13px;">Histórico de Alterações de Contrato</span>
                </div>
                <div class="panel-body" style="padding: 0;">
                  <table class="data-table" style="font-size: 12px;">
                    <thead>
                      <tr>
                        <th>Data/Hora</th>
                        <th>Operador</th>
                        <th>Tipo</th>
                        <th>Novo Valor</th>
                        <th>Garantia Preservada</th>
                        <th>Justificativa</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${contratos.map(c => `
                        <tr>
                          <td style="font-family: var(--font-mono); color: var(--vepc-text-muted);">${escapeHtml(c.criado_em.slice(0, 16))}</td>
                          <td><strong>${escapeHtml(c.operador_nome)}</strong></td>
                          <td><span class="badge badge-avaliacao">${escapeHtml(c.tipo_alteracao)}</span></td>
                          <td><strong style="color: var(--vepc-dourado-claro);">R$ ${(c.valor_novo_centavos / 100).toFixed(2).replace('.', ',')}</strong></td>
                          <td>${c.protecao_preco_preservada ? '✅ Sim' : 'Não'}</td>
                          <td style="color: var(--vepc-text-muted);">${escapeHtml(c.justificativa)}</td>
                        </tr>
                      `).join('')}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;

      modalContainer.querySelector('.btn-fechar-modal').onclick = () => { modalContainer.innerHTML = ''; };

      // Ação de Gerar ou Regerar Convite no Modal
      const btnModalConvite = modalContainer.querySelector('#btn-modal-convite');
      if (btnModalConvite) {
        btnModalConvite.onclick = async () => {
          try {
            const res = (emp.convite_status === 'pendente' || !emp.convite_status)
              ? await api.enviarConvite(empresaId) 
              : await api.reenviarConvite(empresaId);
            exibirModalConvite(res, emp.nome_fantasia);
            abrirModalDetalhes(empresaId);
            carregarEmpresas();
          } catch (err) {
            alert('Erro ao processar convite: ' + err.message);
          }
        };
      }

      const chkFin = modalContainer.querySelector('#check-mod-fin');
      const chkIa = modalContainer.querySelector('#check-mod-ia');
      const lblValor = modalContainer.querySelector('#label-novo-valor');

      function recalcularPreco() {
        let centavos = 1990;
        if (chkFin.checked) centavos += 1000;
        if (chkIa.checked) centavos += 1000;
        lblValor.textContent = `R$ ${(centavos / 100).toFixed(2).replace('.', ',')}/mês`;
        return centavos;
      }

      chkFin.onchange = recalcularPreco;
      chkIa.onchange = recalcularPreco;

      const formContrato = modalContainer.querySelector('#form-alterar-contrato');
      formContrato.onsubmit = async (ev) => {
        ev.preventDefault();
        const novoCentavos = recalcularPreco();
        const just = modalContainer.querySelector('#input-justificativa').value;

        let planoEscolhidoId = 'plano-beta-basico';
        if (chkFin.checked && chkIa.checked) planoEscolhidoId = 'plano-beta-completo';
        else if (chkFin.checked) planoEscolhidoId = 'plano-beta-personalizado-fin';
        else if (chkIa.checked) planoEscolhidoId = 'plano-beta-personalizado-ia';

        try {
          await api.alterarContrato(empresaId, {
            modulo_financeiro_ativo: chkFin.checked,
            modulo_ia_ativo: chkIa.checked,
            plano_id: planoEscolhidoId,
            valor_mensal_contratado_centavos: novoCentavos,
            tipo_alteracao: 'alteracao_modulos',
            justificativa: just
          });
          alert('Contrato atualizado com sucesso! Garantia Beta preservada.');
          abrirModalDetalhes(empresaId);
          carregarEmpresas();
        } catch (err) {
          alert('Erro ao alterar contrato: ' + err.message);
        }
      };

    } catch (err) {
      alert('Erro ao carregar detalhes: ' + err.message);
      modalContainer.innerHTML = '';
    }
  }

  // MODAL DE CADASTRO DE NOVA EMPRESA COM OS 3 CARDS DOS PLANOS BETA
  function abrirModalNovaEmpresa() {
    modalContainer.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-card" style="max-width: 840px; max-height: 85vh; display: flex; flex-direction: column;">
          <div class="modal-header">
            <div>
              <h3 style="font-size: 17px; font-weight: 800; color: #FFFFFF;">Cadastrar Nova Empresa Cliente &bull; Programa BETA</h3>
              <p style="font-size: 11.5px; color: var(--vepc-text-muted); margin-top: 2px;">
                Cadastro seguro e isolado com definição de plano oficial, módulos e marco zero do teste gratuito.
              </p>
            </div>
            <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
          </div>

          <form id="form-nova-empresa" style="display: flex; flex-direction: column; overflow: hidden; flex: 1;">
            <div class="modal-body" style="padding: 20px 24px; overflow-y: auto; max-height: calc(85vh - 130px);">
              <!-- Dados Gerais da Empresa -->
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Nome Fantasia da Empresa *</label>
                  <input type="text" id="novo-nome-fantasia" class="form-control" required placeholder="Ex: Serra Express Turismo" />
                </div>
                <div class="form-group">
                  <label class="form-label">Razão Social</label>
                  <input type="text" id="novo-razao-social" class="form-control" placeholder="Razão Social Ltda" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Nome do Gestor / Responsável *</label>
                  <input type="text" id="novo-responsavel-nome" class="form-control" required placeholder="Nome do proprietário" />
                </div>
                <div class="form-group">
                  <label class="form-label">E-mail do Responsável (Acesso seguro)</label>
                  <input type="email" id="novo-responsavel-email" class="form-control" placeholder="contato@empresa.com" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Telefone / WhatsApp</label>
                  <input type="text" id="novo-responsavel-tel" class="form-control" placeholder="(00) 00000-0000" />
                </div>
                <div class="form-group">
                  <label class="form-label">Dia de Vencimento da Mensalidade</label>
                  <select id="novo-vencimento" class="form-control">
                    <option value="5">Dia 05 de cada mês</option>
                    <option value="10" selected>Dia 10 de cada mês</option>
                    <option value="15">Dia 15 de cada mês</option>
                    <option value="20">Dia 20 de cada mês</option>
                    <option value="25">Dia 25 de cada mês</option>
                  </select>
                </div>
              </div>

              <!-- Seleção Cristalina dos 3 Planos Oficiais Beta -->
              <div style="margin-top: 14px;">
                <label class="form-label" style="font-size: 13px; color: var(--vepc-dourado-claro);">
                  Selecione o Plano Oficial BETA do Aplicativo:
                </label>

                <div class="plan-cards-container">
                  <!-- CARD 1: PLANO BÁSICO -->
                  <div class="plan-option-card selected" id="card-plano-basico" data-plano="beta_basico" data-valor="1990">
                    <span class="plan-card-tag">BETA ENTRADA</span>
                    <div class="plan-card-title">Plano Básico</div>
                    <div class="plan-card-price">R$ 19,90 <small>/mês</small></div>
                    <div class="plan-card-desc">Operação essencial do transporte de passageiros.</div>
                    <ul class="plan-card-features">
                      <li>✔ Cadastro manual de viagens</li>
                      <li>✔ Agenda e calendário</li>
                      <li>✔ Consulta das viagens</li>
                      <li>✔ Configurações do app & ajuda</li>
                      <li style="color: #64748B;">✖ Sem financeiro</li>
                      <li style="color: #64748B;">✖ Sem chat com IA</li>
                    </ul>
                  </div>

                  <!-- CARD 2: PLANO PERSONALIZADO -->
                  <div class="plan-option-card" id="card-plano-personalizado" data-plano="beta_personalizado" data-valor="2990">
                    <span class="plan-card-tag">+1 MÓDULO</span>
                    <div class="plan-card-title">Plano Personalizado</div>
                    <div class="plan-card-price">R$ 29,90 <small>/mês</small></div>
                    <div class="plan-card-desc">Tudo do Básico + UM módulo à escolha do cliente:</div>
                    
                    <div style="margin: 6px 0 10px; display: flex; flex-direction: column; gap: 6px; font-size: 11px;">
                      <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                        <input type="radio" name="opcao_modulo_personalizado" id="opt-mod-fin" value="fin" checked />
                        <span>Opção A: Módulo Financeiro (+R$ 10)</span>
                      </label>
                      <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                        <input type="radio" name="opcao_modulo_personalizado" id="opt-mod-ia" value="ia" />
                        <span>Opção B: Chat com IA (+R$ 10)</span>
                      </label>
                    </div>

                    <ul class="plan-card-features">
                      <li>✔ Todas as funções do Básico</li>
                      <li>✔ 1 Módulo adicional ativo</li>
                    </ul>
                  </div>

                  <!-- CARD 3: PLANO COMPLETO BETA -->
                  <div class="plan-option-card" id="card-plano-completo" data-plano="beta_completo" data-valor="3990">
                    <span class="plan-card-tag" style="background: linear-gradient(135deg, #10B981, #059669);">COMPLETO</span>
                    <div class="plan-card-title">Plano Completo Beta</div>
                    <div class="plan-card-price">R$ 39,90 <small>/mês</small></div>
                    <div class="plan-card-desc">Todas as funcionalidades disponíveis no app Beta.</div>
                    <ul class="plan-card-features">
                      <li>✔ Todas as funções do Básico</li>
                      <li>✔ Módulo Financeiro completo</li>
                      <li>✔ Chat com IA integrado</li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Resumo do Contrato & Configurações de Ativação -->
              <div style="background: var(--vepc-surface-subtle); border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 14px 18px; margin-top: 14px;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                  <span style="font-size: 13px; font-weight: 700; color: #CBD5E1;">Plano Selecionado:</span>
                  <span id="novo-nome-plano-sel" style="font-weight: 800; color: #FFFFFF;">Plano Básico Beta</span>
                </div>
                <div style="display: flex; justify-content: space-between; align-items: center; padding-top: 8px; border-top: 1px dashed var(--vepc-border);">
                  <span style="font-size: 13px; font-weight: 700; color: #CBD5E1;">Valor Mensal Assegurado:</span>
                  <span id="novo-lbl-preco" class="price-pill" style="font-size: 18px; color: var(--vepc-dourado-claro);">R$ 19,90/mês</span>
                </div>
              </div>

              <!-- Regra dos 7 Dias & Garantia Beta -->
              <div style="margin-top: 16px; display: flex; flex-direction: column; gap: 10px;">
                <label style="display: flex; align-items: center; gap: 8px; font-size: 12.5px; font-weight: 700; color: var(--vepc-dourado-claro); cursor: pointer;">
                  <input type="checkbox" id="novo-cliente-beta" checked style="width: 16px; height: 16px;" />
                  <span>Cadastrar como Cliente BETA com Garantia Vitalícia de Preço e Módulos</span>
                </label>

                <label style="display: flex; align-items: center; gap: 8px; font-size: 12.5px; color: #94A3B8; cursor: pointer;">
                  <input type="checkbox" id="novo-teste-7dias" checked style="width: 16px; height: 16px;" />
                  <span>Conceder 7 dias de teste gratuito (Marco zero inicia na ativação da conta pelo cliente)</span>
                </label>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm btn-fechar-modal">Cancelar</button>
              <button type="submit" class="btn btn-primary btn-sm">Salvar Empresa</button>
            </div>
          </form>
        </div>
      </div>
    `;

    modalContainer.querySelector('.btn-fechar-modal').onclick = () => { modalContainer.innerHTML = ''; };

    // Lógica Interativa de Seleção dos 3 Cards de Planos Beta
    const cardBasico = modalContainer.querySelector('#card-plano-basico');
    const cardPersonalizado = modalContainer.querySelector('#card-plano-personalizado');
    const cardCompleto = modalContainer.querySelector('#card-plano-completo');
    const cards = [cardBasico, cardPersonalizado, cardCompleto];

    const lblNomePlano = modalContainer.querySelector('#novo-nome-plano-sel');
    const lblPreco = modalContainer.querySelector('#novo-lbl-preco');
    const optFin = modalContainer.querySelector('#opt-mod-fin');
    const optIa = modalContainer.querySelector('#opt-mod-ia');

    let planoAtivoId = 'plano-beta-basico';
    let modFinAtivo = false;
    let modIaAtivo = false;
    let valorFinalCentavos = 1990;

    function selecionarCard(card) {
      cards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');

      const tipo = card.dataset.plano;
      if (tipo === 'beta_basico') {
        planoAtivoId = 'plano-beta-basico';
        modFinAtivo = false;
        modIaAtivo = false;
        valorFinalCentavos = 1990;
        lblNomePlano.textContent = 'Plano Básico Beta (R$ 19,90)';
        lblPreco.textContent = 'R$ 19,90/mês';
      } else if (tipo === 'beta_personalizado') {
        valorFinalCentavos = 2990;
        if (optFin.checked) {
          planoAtivoId = 'plano-beta-personalizado-fin';
          modFinAtivo = true;
          modIaAtivo = false;
          lblNomePlano.textContent = 'Plano Personalizado com Financeiro (R$ 29,90)';
        } else {
          planoAtivoId = 'plano-beta-personalizado-ia';
          modFinAtivo = false;
          modIaAtivo = true;
          lblNomePlano.textContent = 'Plano Personalizado com Chat IA (R$ 29,90)';
        }
        lblPreco.textContent = 'R$ 29,90/mês';
      } else if (tipo === 'beta_completo') {
        planoAtivoId = 'plano-beta-completo';
        modFinAtivo = true;
        modIaAtivo = true;
        valorFinalCentavos = 3990;
        lblNomePlano.textContent = 'Plano Completo Beta (R$ 39,90)';
        lblPreco.textContent = 'R$ 39,90/mês';
      }
    }

    cardBasico.onclick = () => selecionarCard(cardBasico);
    cardPersonalizado.onclick = () => selecionarCard(cardPersonalizado);
    cardCompleto.onclick = () => selecionarCard(cardCompleto);

    optFin.onchange = () => { if (cardPersonalizado.classList.contains('selected')) selecionarCard(cardPersonalizado); };
    optIa.onchange = () => { if (cardPersonalizado.classList.contains('selected')) selecionarCard(cardPersonalizado); };

    // Submissão do Cadastro
    const form = modalContainer.querySelector('#form-nova-empresa');
    form.onsubmit = async (e) => {
      e.preventDefault();

      const nomeFantasia = modalContainer.querySelector('#novo-nome-fantasia').value.trim();
      const razaoSocial = modalContainer.querySelector('#novo-razao-social').value.trim();
      const respNome = modalContainer.querySelector('#novo-responsavel-nome').value.trim();
      const respEmail = modalContainer.querySelector('#novo-responsavel-email').value.trim();
      const respTel = modalContainer.querySelector('#novo-responsavel-tel').value.trim();
      const vencimento = parseInt(modalContainer.querySelector('#novo-vencimento').value, 10);
      const isBeta = modalContainer.querySelector('#novo-cliente-beta').checked;
      const temTeste7Dias = modalContainer.querySelector('#novo-teste-7dias').checked;

      const payload = {
        nome_fantasia: nomeFantasia,
        razao_social: razaoSocial,
        responsavel_nome: respNome,
        responsavel_email: respEmail,
        responsavel_telefone: respTel,
        dia_vencimento: vencimento,
        plano_id: planoAtivoId,
        modulo_financeiro_ativo: modFinAtivo,
        modulo_ia_ativo: modIaAtivo,
        cliente_beta: isBeta,
        protecao_preco_original: isBeta,
        valor_mensal_contratado_centavos: valorFinalCentavos,
        iniciar_teste_7dias: temTeste7Dias,
        limite_mensal_mensagens_ia: 200
      };

      try {
        await api.criarEmpresa(payload);
        alert(`Empresa "${nomeFantasia}" cadastrada com sucesso!\nPlano: ${lblNomePlano.textContent}\nValor: R$ ${(valorFinalCentavos/100).toFixed(2).replace('.', ',')}/mês`);
        modalContainer.innerHTML = '';
        carregarEmpresas();
      } catch (err) {
        alert('Erro ao cadastrar empresa: ' + err.message);
      }
    };
  }

  container.querySelector('#btn-filtrar').addEventListener('click', carregarEmpresas);
  container.querySelector('#filtro-situacao').addEventListener('change', carregarEmpresas);
  container.querySelector('#filtro-apenas-beta').addEventListener('change', carregarEmpresas);
  container.querySelector('#filtro-busca').addEventListener('keyup', (e) => {
    if (e.key === 'Enter') carregarEmpresas();
  });
  container.querySelector('#btn-nova-empresa').addEventListener('click', abrirModalNovaEmpresa);

  carregarEmpresas();
  return container;
}

function exibirModalConvite(res, empresaNome) {
  const modal = document.createElement('div');
  modal.className = 'modal-backdrop';
  modal.innerHTML = `
    <div class="modal-dialog" style="max-width: 540px;">
      <div class="modal-header">
        <h3>Link de Primeiro Acesso Gerado</h3>
        <button class="btn-close-modal" id="btn-close-convite">&times;</button>
      </div>
      <div class="modal-body">
        <p style="font-size: 13px; color: var(--vepc-text-muted); margin-bottom: 12px; line-height: 1.5;">
          O convite individual de uso único foi gerado com sucesso para a empresa <strong style="color: #FFFFFF;">${escapeHtml(empresaNome || '')}</strong>.
        </p>
        <div style="background: #162032; border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 14px; margin-bottom: 16px;">
          <label style="font-size: 12px; font-weight: 700; color: var(--vepc-dourado-claro); display: block; margin-bottom: 6px;">
            Link do Primeiro Acesso (Uso Único):
          </label>
          <div style="display: flex; gap: 8px;">
            <input type="text" readonly id="input-link-convite" value="${escapeHtml(res.link_primeiro_acesso || '')}" 
              style="flex: 1; font-size: 12px; font-family: var(--font-mono); background: #0A0E17; color: #FFFFFF; border: 1px solid var(--vepc-border); padding: 8px 10px; border-radius: 4px;" />
            <button class="btn btn-secondary btn-sm" id="btn-copiar-link-convite" type="button">Copiar</button>
          </div>
        </div>
        <div style="background: rgba(194, 144, 35, 0.08); border-left: 3px solid var(--vepc-dourado); padding: 10px 14px; font-size: 12px; color: var(--vepc-text-main); margin-bottom: 16px; line-height: 1.5;">
          ⭐ <strong>Marco Zero de Avaliação:</strong> Os 7 dias gratuitos iniciarão apenas quando o cliente acessar este link e definir sua senha definitiva. O administrador apenas gera o acesso.
        </div>
        <div style="display: flex; justify-content: flex-end; gap: 10px;">
          <a href="${escapeHtml(res.link_primeiro_acesso || '')}" target="_blank" class="btn btn-gold btn-sm">
            Abrir Tela de Primeiro Acesso &rarr;
          </a>
          <button class="btn btn-secondary btn-sm" id="btn-fechar-modal-convite" type="button">Fechar</button>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const fechar = () => modal.remove();
  modal.querySelector('#btn-close-convite').onclick = fechar;
  modal.querySelector('#btn-fechar-modal-convite').onclick = fechar;
  modal.querySelector('#btn-copiar-link-convite').onclick = () => {
    const input = modal.querySelector('#input-link-convite');
    input.select();
    navigator.clipboard?.writeText(input.value);
    alert('Link copiado para a área de transferência!');
  };
}
